module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers-4ab9f157f6a341319abf9439200655eb.webp";